
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, Trash2 } from "lucide-react";

interface Visa {
  id: string;
  visa_type_id: string;
  client_name: string;
  passport_number: string;
  status: string;
  issue_date: string;
  expiry_date: string;
  notes: string;
  created_at: string;
  updated_at: string;
  visa_types?: {
    name_ar: string;
    name_en: string;
  };
}

interface VisaCardProps {
  visa: Visa;
  onEdit: () => void;
  onDelete: () => void;
}

const getStatusBadgeVariant = (status: string) => {
    switch (status) {
      case 'approved':
        return 'default';
      case 'pending':
        return 'secondary';
      case 'rejected':
        return 'destructive';
      default:
        return 'outline';
    }
};

const getStatusText = (status: string) => {
    switch (status) {
      case 'approved':
        return 'مقبولة';
      case 'pending':
        return 'قيد المراجعة';
      case 'rejected':
        return 'مرفوضة';
      default:
        return status;
    }
};

export const VisaCard = ({ visa, onEdit, onDelete }: VisaCardProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-start">
            <div>
                <CardTitle>{visa.client_name}</CardTitle>
                <CardDescription>{visa.visa_types?.name_ar}</CardDescription>
            </div>
            <Badge variant={getStatusBadgeVariant(visa.status)}>
                {getStatusText(visa.status)}
            </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 text-sm text-slate-600">
            <p><strong>رقم الجواز:</strong> {visa.passport_number || '-'}</p>
            <p><strong>تاريخ الإصدار:</strong> {visa.issue_date ? new Date(visa.issue_date).toLocaleDateString('ar-SA') : '-'}</p>
            <p><strong>تاريخ الانتهاء:</strong> {visa.expiry_date ? new Date(visa.expiry_date).toLocaleDateString('ar-SA') : '-'}</p>
        </div>
        <div className="flex gap-2 justify-end mt-4">
            <Button
                variant="ghost"
                size="sm"
                onClick={onEdit}
            >
                <Pencil className="h-4 w-4" />
            </Button>
            <Button
                variant="ghost"
                size="sm"
                onClick={onDelete}
                className="text-red-600 hover:text-red-700"
            >
                <Trash2 className="h-4 w-4" />
            </Button>
        </div>
      </CardContent>
    </Card>
  );
};
